import {BarChart, Key, UserCheck, Globe, LogOut} from 'react-feather'
import {Link, useLocation, useNavigate, useNavigation} from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { authContext } from '../Context/authContext'
import { access } from '../constants'
import { appContext } from '../Context/appContext'


const links = [
    {path: '/', title: 'Dashboard', Icon: BarChart, access: access.DASHBOARD},
    {path: '/tenants', title: 'Tenants', Icon: Key, access: access.TENANTS},
    {path: '/tenant-users', title: 'Tenant Users', Icon: UserCheck, access: access.TENANT_USERS},
]

export default function SideBar(){
    const location = useLocation()
    const path = location.pathname
    const navigate  = useNavigate()

    const {logOut, user} = useContext(authContext)
    const {showSidebar, setShowSidebar} = useContext(appContext)

    return (
        <div className={'z-[99999] w-[200px] max-md:absolute top-0 shadow-sm bg-white h-full gap-4 flex flex-col pt-4 pb-6 overflow-auto transition-all duration-500 ease-in-out ' + (showSidebar ? 'max-md:translate-x-[0]' : 'max-md:translate-x-[-100%]')}>
            <h1 className='p-4'>EMS SUPER ADMIN</h1>
            <div className='flex flex-col overflow-auto'>
                {links.map(item => (
                    <Link to={item.path} onClick={() => setShowSidebar(false)} className={`flex items-center gap-2 p-3 ${path == item.path ? 'bg-main' : ''}`}>
                        <item.Icon color={path == item.path ? "#ffffff" : '#000000'} size={20} />
                        <p style={{color: path == item.path ? "#ffffff" : '#000000'}}>{item.title}</p>
                    </Link>
                ))}
            </div>
            <div className='flex justify-around mt-[auto]'>
                <div className='flex items-center gap-1'>
                    {/* <label for='lang' className='text-[11px]'>Language</label> */}
                    <Globe color='#000000' size={13} />
                    <select id="lang" className='text-[13px] outline-none'>
                        <option >English</option>
                        <option >አማርኛ</option>
                    </select>
                </div>
                <button onClick={() => {
                    logOut()
                    setTimeout(() => navigate('/'), 1000)
                }}>
                    <LogOut color='#000000' size={20} />
                </button>
            </div>
        </div>
    )
}